/* Numeros. site script: mobile nav, scroll reveal, form states, quantity stepper, and the playable hand. */
(function () {
  var root = document.querySelector('.ng');
  if (!root) return;

  // mobile nav
  var burger = root.querySelector('.burger'), nav = root.querySelector('.nav');
  if (burger && nav) burger.addEventListener('click', function () {
    var open = nav.classList.toggle('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // reveal on scroll
  var rv = root.querySelectorAll('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  } else rv.forEach(function (e) { e.classList.add('in'); });

  // Shopify returns to ?customer_posted=true#<form id> after a customer form posts
  if (/customer_posted=true/.test(location.search) && location.hash) {
    var f = document.getElementById(location.hash.slice(1));
    if (f) f.classList.add('done');
  }

  // quantity stepper rewrites the cart permalink
  root.querySelectorAll('[data-qty]').forEach(function (q) {
    var out = q.querySelector('output'), link = document.querySelector(q.getAttribute('data-qty')), n = 1;
    q.addEventListener('click', function (e) {
      var d = e.target.getAttribute('data-d');
      if (!d) return;
      n = Math.max(1, Math.min(10, n + Number(d)));
      out.textContent = n;
      if (link) link.href = link.getAttribute('data-base') + ':' + n;
    });
  });

  // ---------- the playable hand ----------
  var POOL = { '0': 4, '1': 8, '2': 8, '3': 8, '4': 7, '5': 7, '6': 5, '7': 5, '8': 4, '9': 4, '=': 18, '+': 9, '−': 6, '×': 4, '÷': 3 };
  var OPS = '+−×÷';

  // Returns {ok:true} or {ok:false, why:'...'} for one line of tiles, by the printed rules.
  function check(tiles) {
    var s = tiles.join('');
    if (tiles.length < 5) return { ok: false, why: 'An equation needs at least five tiles, like 2 + 3 = 5.' };
    var parts = s.split('=');
    if (parts.length < 2) return { ok: false, why: 'Every equation needs an equals tile.' };
    if (parts.length > 2) return { ok: false, why: 'One equals tile per equation.' };
    if (!/[+−×÷]/.test(parts[0])) return { ok: false, why: 'Put some math before the equals tile: at least one + − × or ÷.' };
    var vals = [];
    for (var i = 0; i < 2; i++) {
      var v = evalSide(parts[i]);
      if (v.why) return { ok: false, why: v.why };
      vals.push(v.n);
    }
    if (vals[0] !== vals[1]) return { ok: false, why: 'Bad math! ' + show(parts[0]) + ' is ' + vals[0] + ', and ' + show(parts[1]) + ' is ' + vals[1] + '.' };
    return { ok: true };
  }
  function show(side) { return side.replace(/([+−×÷])/g, ' $1 '); }
  function evalSide(side) {
    if (!side) return { why: 'Something has to sit on both sides of the equals tile.' };
    var toks = side.match(/\d+|[+−×÷]/g) || [];
    if (toks.join('') !== side) return { why: 'That does not read as math yet.' };
    for (var i = 0; i < toks.length; i++) {
      var isNum = /\d/.test(toks[i]);
      if ((i % 2 === 0) !== isNum) return { why: 'Signs go between numbers, never first, last or side by side.' };
      if (isNum && toks[i].length > 3) return { why: 'Numbers stop at three digits. 999 is the biggest.' };
      if (isNum && toks[i].length > 1 && toks[i][0] === '0') return { why: 'No leading zeros: 07 is not a number.' };
    }
    if (toks.length % 2 === 0) return { why: 'Signs go between numbers, never first, last or side by side.' };
    // multiply and divide first, left to right
    var st = [Number(toks[0])], ops = [];
    for (var j = 1; j < toks.length; j += 2) {
      var op = toks[j], n = Number(toks[j + 1]);
      if (op === '×') st[st.length - 1] *= n;
      else if (op === '÷') {
        if (n === 0) return { why: 'Nobody divides by zero. Not even here.' };
        if (st[st.length - 1] % n !== 0) return { why: 'Division has to come out whole. ' + st[st.length - 1] + ' ÷ ' + n + ' does not.' };
        st[st.length - 1] /= n;
      } else { ops.push(op); st.push(n); }
    }
    var total = st[0];
    for (var k = 0; k < ops.length; k++) total = ops[k] === '+' ? total + st[k + 1] : total - st[k + 1];
    if (total < 0) return { why: 'No negative numbers in this game.' };
    return { n: total };
  }
  window.ngCheck = check; // exposed for tests

  root.querySelectorAll('[data-ng-demo]').forEach(function (el) {
    var size = Number(el.getAttribute('data-hand')) || 18;
    var bag, hand, line, done, swapping;
    el.innerHTML =
      '<div class="bar"><span>In your hand: <b data-n="hand"></b></span><span>In the bag: <b data-n="bag"></b></span></div>' +
      '<div class="line" aria-label="Your equation" data-empty="Tap tiles below to build an equation here."></div>' +
      '<p class="msg" role="status" aria-live="polite"></p>' +
      '<div class="hand" aria-label="Your tiles"></div>' +
      '<div class="acts"><button type="button" class="btn sm" data-a="check">Check it</button>' +
      '<button type="button" class="btn sm ghost" data-a="clear">Clear</button>' +
      '<button type="button" class="btn sm ghost" data-a="swap">Stuck? Swap 1 for 2</button>' +
      '<button type="button" class="btn sm ghost" data-a="deal">New hand</button></div>' +
      '<ul class="done" aria-label="Equations you built"></ul>';
    var $ = function (s) { return el.querySelector(s); };
    var lineEl = $('.line'), handEl = $('.hand'), msgEl = $('.msg'), doneEl = $('.done');

    function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    function deal() {
      bag = [];
      Object.keys(POOL).forEach(function (k) { for (var i = 0; i < POOL[k]; i++) bag.push(k); });
      shuffle(bag);
      hand = bag.splice(0, size); line = []; done = []; swapping = false;
      say('Go! Build an equation. Tap a tile to play it, tap it again to take it back.', '');
      draw();
    }
    function say(t, cls) { msgEl.textContent = t; msgEl.className = 'msg' + (cls ? ' ' + cls : ''); }
    function tile(ch, i, where) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 't' + (OPS.indexOf(ch) > -1 || ch === '=' ? ' op' : '');
      b.textContent = ch; b.setAttribute('data-i', i); b.setAttribute('data-w', where);
      b.setAttribute('aria-label', (where === 'hand' ? 'Play ' : 'Take back ') + name(ch));
      return b;
    }
    function name(ch) { return { '=': 'equals', '+': 'plus', '−': 'minus', '×': 'times', '÷': 'divided by' }[ch] || ch; }
    function draw() {
      lineEl.innerHTML = ''; handEl.innerHTML = ''; doneEl.innerHTML = '';
      line.forEach(function (c, i) { lineEl.appendChild(tile(c, i, 'line')); });
      hand.forEach(function (c, i) { handEl.appendChild(tile(c, i, 'hand')); });
      done.forEach(function (d) { var li = document.createElement('li'); li.textContent = d; doneEl.appendChild(li); });
      $('[data-n=hand]').textContent = hand.length + line.length;
      $('[data-n=bag]').textContent = bag.length;
      el.classList.toggle('swap', swapping);
      $('[data-a=swap]').disabled = bag.length < 2;
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !el.contains(b)) return;
      var a = b.getAttribute('data-a'), w = b.getAttribute('data-w'), i = Number(b.getAttribute('data-i'));
      if (w === 'hand') {
        if (swapping) {
          bag.unshift(hand.splice(i, 1)[0]);
          hand.push(bag.pop(), bag.pop());
          swapping = false; say('Swapped. One back in the bag, two new tiles.', '');
        } else { line.push(hand.splice(i, 1)[0]); say('', ''); }
      } else if (w === 'line') { hand.push(line.splice(i, 1)[0]); say('', ''); }
      else if (a === 'clear') { hand = hand.concat(line); line = []; swapping = false; say('', ''); }
      else if (a === 'deal') { return deal(); }
      else if (a === 'swap') {
        hand = hand.concat(line); line = []; swapping = !swapping;
        say(swapping ? 'Tap the tile you want to throw back.' : '', '');
      } else if (a === 'check') {
        var r = check(line);
        if (!r.ok) say(r.why, 'no');
        else {
          done.push(line.join(' ')); line = [];
          if (!hand.length) {
            if (bag.length >= 3) { hand = bag.splice(-3, 3); say('Numeros! Hand empty, so everyone draws 3. Keep going.', 'ok'); }
            else { say('Numeros! Hand empty and the bag is dry. That is the win.', 'ok'); }
          } else say('That works. ' + hand.length + ' tiles to go.', 'ok');
        }
      }
      draw();
    });
    deal();
  });
})();

/* Klaviyo (added 2026-10-05): every Numeros email form (footer newsletter, reserve forms; not the contact form) also
   subscribes the email to the list "NG - Newsletter" (WJwusm) in the Davision Klaviyo account (UneZNa).
   The Shopify customer form still submits as before. */
(function () {
  document.querySelectorAll('.ng form.reserve:not(.contact)').forEach(function (form) {
    form.addEventListener('submit', function () {
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      var props = {};
      if (tags && /reserve-numeros/.test(tags.value)) props.ng_reserve = 'yes';
      var body = { data: { type: 'subscription', attributes: { custom_source: 'Numeros site form', profile: { data: { type: 'profile', attributes: {
        email: email.value.trim(), properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: 'WJwusm' } } } } };
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UneZNa', { method: 'POST', keepalive: true,
          headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
      } catch (e) {}
    });
  });
})();
